export const BRAND_HEX = "#2F76E5"
